export enum RealTimeRecorderParams {
  RecorderId = 'recorderId',
}

export enum RealTimeRecorderListTab {
  List = 'list',
  Issues = 'issues',
}
